import ky from 'ky'
import {STATUS_UNATHORIZED} from '../core/errors'
import {getUserToken, logoutOnUnauthorized} from '../utils/token'

const api = ky.extend({
    prefixUrl: `${window.location.origin}/api/v1/`,
    hooks: {
        beforeRequest: [
            (req) => {
                req.headers.set(
                    'Authorization',
                    'Bearer ' + (getUserToken() || ''),
                )
            },
        ],
        beforeError: [
            (error) => {
                if (error.response.status === STATUS_UNATHORIZED) {
                    logoutOnUnauthorized()
                    return {...error, message: 'ERROR_SESSION_EXPIRED'}
                }
                return error
            },
        ],
    },
    cache: 'no-cache',
})

export default api
